import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'biz-sap-config-list',
  templateUrl: './sap-config-list.component.html',
  styleUrls: ['./sap-config-list.component.scss']
})
export class SapConfigListComponent implements OnInit {

  public searchValue = "";

  @Input() connectors: ISAPConfiguration[];
  @Input() selectedConnector: ISAPConfiguration;
  @Input() isLoading: boolean;
  @Output() onSelectConnector : EventEmitter<ISAPConfiguration> = new EventEmitter<ISAPConfiguration>();

  constructor() { }

  ngOnInit() {
  }

  public selectConnector(connector: ISAPConfiguration) {
    this.onSelectConnector.emit(connector);
  }
}
